<template>
  <form-group class="file-input"
              :label="label"
              :errors="internalErrors"
              @focus="focus">

    <div uk-form-custom="target: true">
      <input ref="primaryInput"
             type="file"
             :disabled="disabled"
             @change="selectFiles"
             :multiple="multiple">
      <input ref="dummy"
             class="uk-input dummy-input"
             :class="inputCss"
             type="text"
             :placeholder="placeholder"
             readonly>
    </div>
    <common-button icon="trash" @click="clearFile"/>
  </form-group>
</template>

<script>
import Input from '@/mixins/Input';
import CommonButton from '@/components/CommonButton';

export default {
  name: 'file-input',
  mixins: [Input],
  components: { CommonButton },
  props: {
    value: [String, FileList, File],
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    placeholder() {
      if (this.internalValue) {
        return [...this.internalValue]
          .map(file => file.name)
          .join(', ');
      }
      return this.$t('placeholder.file');
    },
  },
  methods: {
    selectFiles(event) {
      const files = event.target.files; // Is a FileList
      if (this.multiple) {
        this.internalValue = files;
      } else {
        this.internalValue = files[0];
      }
      this.$emit('input', this.internalValue);
      this.$emit('change', this.internalValue);
    },
    clearFile() {
      this.internalValue = '';
      this.$refs.primaryInput.value = '';
      this.$refs.dummy.value = '';
      this.clearErrors();
      this.$emit('input', null);
      this.$emit('change', null);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../theme/variables.scss';
input.uk-form-danger.dummy-input:disabled {
  border-color: $alert-danger-color;
}
</style>



// WEBPACK FOOTER //
// FileInput.vue?2ad7a606